import { REGEXP } from '@/shared/regexp'
import { parseNumber, AsYouType } from 'libphonenumber-js'
import countries from '../assets/all-countries'

const DEF_COUNTRY = countries.find(c => c.iso2 === 'US')

export const CustomValidation = {
  fullName: (value) => {
    return REGEXP.fullName.test(value)
  },
  phone: (value) => {
    const formatter = new AsYouType(); // eslint-disable-line
    formatter.input(value)
    const country = countries.find(c => c.iso2.toLowerCase() === formatter.country) || DEF_COUNTRY
    let pNumber = parseNumber(value, country.iso2)
    let valid = !(
      Object.keys(pNumber).length === 0 && pNumber.constructor === Object
    )
    return valid
  }
}



// WEBPACK FOOTER //
// ./scripts/src/shared/custom-validation.js